import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CreditPayment from "./CreditPayment";
import OnlinePayment from "./OnlinePayment";
import CardPayment from "./CardPaymentBox";
import useUploadReceipt, {
    UPLOAD_RECEIPT_WARNING_TYPE,
} from "@/components/base/payment/hooks/useUploadReceipt";
import { numberWithCommas } from "@/utils/numbers";

export default function PaymentDialog({
    open,
    handleClose,
    title = "پرداخت جریمه",
    warning,
}) {
    let text;
    if (warning?.reason == "LESSON_ABSENCE") {
        text = `به دلیل تاخیر بیشتر از یک روز در مشاهده درس فعلی ، می توانید حساب کاربری خود را رفع مسدودیت کنید.`;
    } else if (warning?.reason == "EXAM_FAILURE") {
        text = `به دلیل کسب نکردن نمره قبولی پس از دو مرتبه شرکت در آزمون ، می توانید حساب کاربری خود را رفع مسدودیت کنید.`;
    } else if (warning?.reason == "EXAM_ABSENCE") {
        text = `به دلیل شرکت نکردن به موقع در آزمون ، می توانید حساب کاربری خود را رفع مسدودیت کنید.`;
    }
    const payment = warning?.finalCharge ?? 0;

    const { openUploadReceiptDialog } = useUploadReceipt();

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                PaperProps={{
                    sx: (theme) => ({
                        margin: {
                            xs: theme.spacing(1),
                            sm: theme.spacing(2),
                        },
                    }),
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div className="text-[0.95rem]">
                        با پرداخت مبلغ{" "}
                        <span className="font-bold px-1 text-primary text-[0.95rem]">
                            {numberWithCommas(payment)} تومان
                        </span>{" "}
                        {text}
                    </div>

                    <br />

                    <OnlinePayment
                        preTitle="روش اول"
                        handleClose={handleClose}
                    />

                    <br />
                    <CardPayment
                        preTitle="روش دوم"
                        charge={payment}
                        onClose={handleClose}
                        onOpenUploader={() => {
                            openUploadReceiptDialog(
                                UPLOAD_RECEIPT_WARNING_TYPE,
                                { warning }
                            );
                        }}
                        displayButton
                    />

                    <br />
                    <CreditPayment
                        preTitle="روش سوم"
                        charge={payment}
                        handleClose={handleClose}
                    />
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    zIndex: 10001,
    "& .MuiDialogContent-root": {
        padding: "10px",
        "@media (min-width: 600px)": {
            padding: theme.spacing(2),
        },
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));
